/**
 * Do not edit directly
 * Generated on Wed, 18 Jun 2025 14:56:42 GMT
 */

export const iconsaxYoutube = "/assets/icons/iconsax/youtube.svg";
export const iconsaxX = "/assets/icons/iconsax/x.svg";
export const iconsaxWoman = "/assets/icons/iconsax/woman.svg";
export const iconsaxWind = "/assets/icons/iconsax/wind.svg";
export const iconsaxWind2 = "/assets/icons/iconsax/wind-2.svg";
export const iconsaxWifi = "/assets/icons/iconsax/wifi.svg";
export const iconsaxWifiSquare = "/assets/icons/iconsax/wifi-square.svg";
export const iconsaxWeight = "/assets/icons/iconsax/weight.svg";
export const iconsaxWeight1 = "/assets/icons/iconsax/weight-1.svg";
export const iconsaxWatch = "/assets/icons/iconsax/watch.svg";
export const iconsaxWatchStatus = "/assets/icons/iconsax/watch-status.svg";
export const iconsaxWarning2 = "/assets/icons/iconsax/warning-2.svg";
export const iconsaxWallet = "/assets/icons/iconsax/wallet.svg";
export const iconsaxWalletSearch = "/assets/icons/iconsax/wallet-search.svg";
export const iconsaxWalletRemove = "/assets/icons/iconsax/wallet-remove.svg";
export const iconsaxWalletMoney = "/assets/icons/iconsax/wallet-money.svg";
export const iconsaxWalletMinus = "/assets/icons/iconsax/wallet-minus.svg";
export const iconsaxWalletCheck = "/assets/icons/iconsax/wallet-check.svg";
export const iconsaxWalletAdd = "/assets/icons/iconsax/wallet-add.svg";
export const iconsaxWalletAdd1 = "/assets/icons/iconsax/wallet-add-1.svg";
export const iconsaxWallet3 = "/assets/icons/iconsax/wallet-3.svg";
export const iconsaxWallet2 = "/assets/icons/iconsax/wallet-2.svg";
export const iconsaxWallet1 = "/assets/icons/iconsax/wallet-1.svg";
export const iconsaxVolumeUp = "/assets/icons/iconsax/volume-up.svg";
export const iconsaxVolumeSlash = "/assets/icons/iconsax/volume-slash.svg";
export const iconsaxVolumeMute = "/assets/icons/iconsax/volume-mute.svg";
export const iconsaxVolumeLow = "/assets/icons/iconsax/volume-low.svg";
export const iconsaxVolumeLow1 = "/assets/icons/iconsax/volume-low-1.svg";
export const iconsaxVolumeHigh = "/assets/icons/iconsax/volume-high.svg";
export const iconsaxVolumeCross = "/assets/icons/iconsax/volume-cross.svg";
export const iconsaxVoiceSquare = "/assets/icons/iconsax/voice-square.svg";
export const iconsaxVoiceCricle = "/assets/icons/iconsax/voice-cricle.svg";
export const iconsaxVideo = "/assets/icons/iconsax/video.svg";
export const iconsaxVideoVertical = "/assets/icons/iconsax/video-vertical.svg";
export const iconsaxVideoTime = "/assets/icons/iconsax/video-time.svg";
export const iconsaxVideoTick = "/assets/icons/iconsax/video-tick.svg";
export const iconsaxVideoSquare = "/assets/icons/iconsax/video-square.svg";
export const iconsaxVideoSlash = "/assets/icons/iconsax/video-slash.svg";
export const iconsaxVideoRemove = "/assets/icons/iconsax/video-remove.svg";
export const iconsaxVideoPlay = "/assets/icons/iconsax/video-play.svg";
export const iconsaxVideoOctagon = "/assets/icons/iconsax/video-octagon.svg";
export const iconsaxVideoHorizontal = "/assets/icons/iconsax/video-horizontal.svg";
export const iconsaxVideoCircle = "/assets/icons/iconsax/video-circle.svg";
export const iconsaxVideoAdd = "/assets/icons/iconsax/video-add.svg";
export const iconsaxVerify = "/assets/icons/iconsax/verify.svg";
export const iconsaxUser = "/assets/icons/iconsax/user.svg";
export const iconsaxUserTick = "/assets/icons/iconsax/user-tick.svg";
export const iconsaxUserTag = "/assets/icons/iconsax/user-tag.svg";
export const iconsaxUserSquare = "/assets/icons/iconsax/user-square.svg";
export const iconsaxUserSearch = "/assets/icons/iconsax/user-search.svg";
export const iconsaxUserRemove = "/assets/icons/iconsax/user-remove.svg";
export const iconsaxUserOctagon = "/assets/icons/iconsax/user-octagon.svg";
export const iconsaxUserMinus = "/assets/icons/iconsax/user-minus.svg";
export const iconsaxUserEdit = "/assets/icons/iconsax/user-edit.svg";
export const iconsaxUserCirlceAdd = "/assets/icons/iconsax/user-cirlce-add.svg";
export const iconsaxUserAdd = "/assets/icons/iconsax/user-add.svg";
export const iconsaxUnlock = "/assets/icons/iconsax/unlock.svg";
export const iconsaxUnlimited = "/assets/icons/iconsax/unlimited.svg";
export const iconsaxUndo = "/assets/icons/iconsax/undo.svg";
export const iconsaxTwitter = "/assets/icons/iconsax/twitter.svg";
export const iconsaxTrushSquare = "/assets/icons/iconsax/trush-square.svg";
export const iconsaxTruck = "/assets/icons/iconsax/truck.svg";
export const iconsaxTruckTime = "/assets/icons/iconsax/truck-time.svg";
export const iconsaxTruckTick = "/assets/icons/iconsax/truck-tick.svg";
export const iconsaxTruckRemove = "/assets/icons/iconsax/truck-remove.svg";
export const iconsaxTriangle = "/assets/icons/iconsax/triangle.svg";
export const iconsaxTrendUp = "/assets/icons/iconsax/trend-up.svg";
export const iconsaxTrendDown = "/assets/icons/iconsax/trend-down.svg";
export const iconsaxTree = "/assets/icons/iconsax/tree.svg";
export const iconsaxTrash = "/assets/icons/iconsax/trash.svg";
export const iconsaxTranslate = "/assets/icons/iconsax/translate.svg";
export const iconsaxTransactionMinus = "/assets/icons/iconsax/transaction-minus.svg";
export const iconsaxTrade = "/assets/icons/iconsax/trade.svg";
export const iconsaxToggleOn = "/assets/icons/iconsax/toggle-on.svg";
export const iconsaxToggleOnCircle = "/assets/icons/iconsax/toggle-on-circle.svg";
export const iconsaxToggleOff = "/assets/icons/iconsax/toggle-off.svg";
export const iconsaxToggleOffCircle = "/assets/icons/iconsax/toggle-off-circle.svg";
export const iconsaxTimer = "/assets/icons/iconsax/timer.svg";
export const iconsaxTimerStart = "/assets/icons/iconsax/timer-start.svg";
export const iconsaxTimerPause = "/assets/icons/iconsax/timer-pause.svg";
export const iconsaxTimer1 = "/assets/icons/iconsax/timer-1.svg";
export const iconsaxTiktok = "/assets/icons/iconsax/tiktok.svg";
export const iconsaxTicket = "/assets/icons/iconsax/ticket.svg";
export const iconsaxTicketStar = "/assets/icons/iconsax/ticket-star.svg";
export const iconsaxTicketExpired = "/assets/icons/iconsax/ticket-expired.svg";
export const iconsaxTicketDiscount = "/assets/icons/iconsax/ticket-discount.svg";
export const iconsaxTicket2 = "/assets/icons/iconsax/ticket-2.svg";
export const iconsaxTick = "/assets/icons/iconsax/tick.svg";
export const iconsaxTickSquare = "/assets/icons/iconsax/tick-square.svg";
export const iconsaxTickCircle = "/assets/icons/iconsax/tick-circle.svg";
export const iconsaxTextalignRight = "/assets/icons/iconsax/textalign-right.svg";
export const iconsaxTextalignLeft = "/assets/icons/iconsax/textalign-left.svg";
export const iconsaxTextalignJustifyright = "/assets/icons/iconsax/textalign-justifyright.svg";
export const iconsaxTextalignJustifyleft = "/assets/icons/iconsax/textalign-justifyleft.svg";
export const iconsaxTextalignJustifycenter = "/assets/icons/iconsax/textalign-justifycenter.svg";
export const iconsaxTextalignCenter = "/assets/icons/iconsax/textalign-center.svg";
export const iconsaxText = "/assets/icons/iconsax/text.svg";
export const iconsaxTextUnderline = "/assets/icons/iconsax/text-underline.svg";
export const iconsaxTextItalic = "/assets/icons/iconsax/text-italic.svg";
export const iconsaxTextBold = "/assets/icons/iconsax/text-bold.svg";
export const iconsaxTextBlock = "/assets/icons/iconsax/text-block.svg";
export const iconsaxTeacher = "/assets/icons/iconsax/teacher.svg";
export const iconsaxTask = "/assets/icons/iconsax/task.svg";
export const iconsaxTaskSquare = "/assets/icons/iconsax/task-square.svg";
export const iconsaxTag = "/assets/icons/iconsax/tag.svg";
export const iconsaxTagUser = "/assets/icons/iconsax/tag-user.svg";
export const iconsaxTagRight = "/assets/icons/iconsax/tag-right.svg";
export const iconsaxTagCross = "/assets/icons/iconsax/tag-cross.svg";
export const iconsaxTag2 = "/assets/icons/iconsax/tag-2.svg";
export const iconsaxSun = "/assets/icons/iconsax/sun.svg";
export const iconsaxSunFog = "/assets/icons/iconsax/sun-fog.svg";
export const iconsaxSun1 = "/assets/icons/iconsax/sun-1.svg";
export const iconsaxSubtitle = "/assets/icons/iconsax/subtitle.svg";
export const iconsaxStrongbox = "/assets/icons/iconsax/strongbox.svg";
export const iconsaxStrongbox2 = "/assets/icons/iconsax/strongbox-2.svg";
export const iconsaxStory = "/assets/icons/iconsax/story.svg";
export const iconsaxStop = "/assets/icons/iconsax/stop.svg";
export const iconsaxStopCircle = "/assets/icons/iconsax/stop-circle.svg";
export const iconsaxStickynote = "/assets/icons/iconsax/stickynote.svg";
export const iconsaxSticker = "/assets/icons/iconsax/sticker.svg";
export const iconsaxStatus = "/assets/icons/iconsax/status.svg";
export const iconsaxStatusUp = "/assets/icons/iconsax/status-up.svg";
export const iconsaxStar = "/assets/icons/iconsax/star.svg";
export const iconsaxStarSlash = "/assets/icons/iconsax/star-slash.svg";
export const iconsaxStar1 = "/assets/icons/iconsax/star-1.svg";
export const iconsaxSpeedometer = "/assets/icons/iconsax/speedometer.svg";
export const iconsaxSpeaker = "/assets/icons/iconsax/speaker.svg";
export const iconsaxSound = "/assets/icons/iconsax/sound.svg";
export const iconsaxSort = "/assets/icons/iconsax/sort.svg";
export const iconsaxSms = "/assets/icons/iconsax/sms.svg";
export const iconsaxSmsTracking = "/assets/icons/iconsax/sms-tracking.svg";
export const iconsaxSmsStar = "/assets/icons/iconsax/sms-star.svg";
export const iconsaxSmsSearch = "/assets/icons/iconsax/sms-search.svg";
export const iconsaxSmsNotification = "/assets/icons/iconsax/sms-notification.svg";
export const iconsaxSmsEdit = "/assets/icons/iconsax/sms-edit.svg";
export const iconsaxSmileys = "/assets/icons/iconsax/smileys.svg";
export const iconsaxSmartHome = "/assets/icons/iconsax/smart-home.svg";
export const iconsaxSmartCar = "/assets/icons/iconsax/smart-car.svg";
export const iconsaxSmallcaps = "/assets/icons/iconsax/smallcaps.svg";
export const iconsaxSlider = "/assets/icons/iconsax/slider.svg";
export const iconsaxSliderVertical = "/assets/icons/iconsax/slider-vertical.svg";
export const iconsaxSliderVertical1 = "/assets/icons/iconsax/slider-vertical-1.svg";
export const iconsaxSliderHorizontal = "/assets/icons/iconsax/slider-horizontal.svg";
export const iconsaxSliderHorizontal1 = "/assets/icons/iconsax/slider-horizontal-1.svg";
export const iconsaxSlash = "/assets/icons/iconsax/slash.svg";
export const iconsaxSize = "/assets/icons/iconsax/size.svg";
export const iconsaxSimcard = "/assets/icons/iconsax/simcard.svg";
export const iconsaxSimcard2 = "/assets/icons/iconsax/simcard-2.svg";
export const iconsaxSimcard1 = "/assets/icons/iconsax/simcard-1.svg";
export const iconsaxSignpost = "/assets/icons/iconsax/signpost.svg";
export const iconsaxSidebarTop = "/assets/icons/iconsax/sidebar-top.svg";
export const iconsaxSidebarRight = "/assets/icons/iconsax/sidebar-right.svg";
export const iconsaxSidebarLeft = "/assets/icons/iconsax/sidebar-left.svg";
export const iconsaxSidebarBottom = "/assets/icons/iconsax/sidebar-bottom.svg";
export const iconsaxShoppingCart = "/assets/icons/iconsax/shopping-cart.svg";
export const iconsaxShoppingBag = "/assets/icons/iconsax/shopping-bag.svg";
export const iconsaxShop = "/assets/icons/iconsax/shop.svg";
export const iconsaxShopRemove = "/assets/icons/iconsax/shop-remove.svg";
export const iconsaxShopAdd = "/assets/icons/iconsax/shop-add.svg";
export const iconsaxShip = "/assets/icons/iconsax/ship.svg";
export const iconsaxShield = "/assets/icons/iconsax/shield.svg";
export const iconsaxShieldTick = "/assets/icons/iconsax/shield-tick.svg";
export const iconsaxShieldSlash = "/assets/icons/iconsax/shield-slash.svg";
export const iconsaxShieldSecurity = "/assets/icons/iconsax/shield-security.svg";
export const iconsaxShieldSearch = "/assets/icons/iconsax/shield-search.svg";
export const iconsaxShieldCross = "/assets/icons/iconsax/shield-cross.svg";
export const iconsaxShare = "/assets/icons/iconsax/share.svg";
export const iconsaxShapes = "/assets/icons/iconsax/shapes.svg";
export const iconsaxShapes2 = "/assets/icons/iconsax/shapes-2.svg";
export const iconsaxShapes1 = "/assets/icons/iconsax/shapes-1.svg";
export const iconsaxSettings = "/assets/icons/iconsax/settings.svg";
export const iconsaxSetting = "/assets/icons/iconsax/setting.svg";
export const iconsaxSetting5 = "/assets/icons/iconsax/setting-5.svg";
export const iconsaxSetting4 = "/assets/icons/iconsax/setting-4.svg";
export const iconsaxSetting3 = "/assets/icons/iconsax/setting-3.svg";
export const iconsaxSetting2 = "/assets/icons/iconsax/setting-2.svg";
export const iconsaxSend = "/assets/icons/iconsax/send.svg";
export const iconsaxSendSquare = "/assets/icons/iconsax/send-square.svg";
export const iconsaxSendSqaure2 = "/assets/icons/iconsax/send-sqaure-2.svg";
export const iconsaxSend2 = "/assets/icons/iconsax/send-2.svg";
export const iconsaxSend1 = "/assets/icons/iconsax/send-1.svg";
export const iconsaxSecurity = "/assets/icons/iconsax/security.svg";
export const iconsaxSecurityUser = "/assets/icons/iconsax/security-user.svg";
export const iconsaxSecurityTime = "/assets/icons/iconsax/security-time.svg";
export const iconsaxSecuritySafe = "/assets/icons/iconsax/security-safe.svg";
export const iconsaxSecurityCard = "/assets/icons/iconsax/security-card.svg";
export const iconsaxSearchZoomOut = "/assets/icons/iconsax/search-zoom-out.svg";
export const iconsaxSearchZoomOut1 = "/assets/icons/iconsax/search-zoom-out-1.svg";
export const iconsaxSearchZoomIn = "/assets/icons/iconsax/search-zoom-in.svg";
export const iconsaxSearchZoomIn1 = "/assets/icons/iconsax/search-zoom-in-1.svg";
export const iconsaxSearchStatus = "/assets/icons/iconsax/search-status.svg";
export const iconsaxSearchStatus1 = "/assets/icons/iconsax/search-status-1.svg";
export const iconsaxSearchNormal = "/assets/icons/iconsax/search-normal.svg";
export const iconsaxSearchNormal1 = "/assets/icons/iconsax/search-normal-1.svg";
export const iconsaxSearchFavorite = "/assets/icons/iconsax/search-favorite.svg";
export const iconsaxSearchFavorite1 = "/assets/icons/iconsax/search-favorite-1.svg";
export const iconsaxScroll = "/assets/icons/iconsax/scroll.svg";
export const iconsaxScreenmirroring = "/assets/icons/iconsax/screenmirroring.svg";
export const iconsaxScissor = "/assets/icons/iconsax/scissor.svg";
export const iconsaxScissor2 = "/assets/icons/iconsax/scissor-2.svg";
export const iconsaxScissor1 = "/assets/icons/iconsax/scissor-1.svg";
export const iconsaxScanning = "/assets/icons/iconsax/scanning.svg";
export const iconsaxScanner = "/assets/icons/iconsax/scanner.svg";
export const iconsaxScan = "/assets/icons/iconsax/scan.svg";
export const iconsaxScanBarcode = "/assets/icons/iconsax/scan-barcode.svg";
export const iconsaxSaveRemove = "/assets/icons/iconsax/save-remove.svg";
export const iconsaxSaveMinus = "/assets/icons/iconsax/save-minus.svg";
export const iconsaxSaveAdd = "/assets/icons/iconsax/save-add.svg";
export const iconsaxSave2 = "/assets/icons/iconsax/save-2.svg";
export const iconsaxSagittarius = "/assets/icons/iconsax/sagittarius.svg";
export const iconsaxSafeHome = "/assets/icons/iconsax/safe-home.svg";
export const iconsaxRuler = "/assets/icons/iconsax/ruler.svg";
export const iconsaxRulerPen = "/assets/icons/iconsax/ruler&pen.svg";
export const iconsaxRowVertical = "/assets/icons/iconsax/row-vertical.svg";
export const iconsaxRowHorizontal = "/assets/icons/iconsax/row-horizontal.svg";
export const iconsaxRouting = "/assets/icons/iconsax/routing.svg";
export const iconsaxRouting2 = "/assets/icons/iconsax/routing-2.svg";
export const iconsaxRouteSquare = "/assets/icons/iconsax/route-square.svg";
export const iconsaxRotateRight = "/assets/icons/iconsax/rotate-right.svg";
export const iconsaxRotateRight1 = "/assets/icons/iconsax/rotate-right-1.svg";
export const iconsaxRotateLeft = "/assets/icons/iconsax/rotate-left.svg";
export const iconsaxRotateLeft1 = "/assets/icons/iconsax/rotate-left-1.svg";
export const iconsaxReserve = "/assets/icons/iconsax/reserve.svg";
export const iconsaxRepeateOne = "/assets/icons/iconsax/repeate-one.svg";
export const iconsaxRepeateMusic = "/assets/icons/iconsax/repeate-music.svg";
export const iconsaxRepeat = "/assets/icons/iconsax/repeat.svg";
export const iconsaxRepeatCircle = "/assets/icons/iconsax/repeat-circle.svg";
export const iconsaxRefresh = "/assets/icons/iconsax/refresh.svg";
export const iconsaxRefreshSquare2 = "/assets/icons/iconsax/refresh-square-2.svg";
export const iconsaxRefreshRightSquare = "/assets/icons/iconsax/refresh-right-square.svg";
export const iconsaxRefreshLeftSquare = "/assets/icons/iconsax/refresh-left-square.svg";
export const iconsaxRefreshCircle = "/assets/icons/iconsax/refresh-circle.svg";
export const iconsaxRefresh2 = "/assets/icons/iconsax/refresh-2.svg";
export const iconsaxRedo = "/assets/icons/iconsax/redo.svg";
export const iconsaxRecoveryConvert = "/assets/icons/iconsax/recovery-convert.svg";
export const iconsaxRecord = "/assets/icons/iconsax/record.svg";
export const iconsaxRecordCircle = "/assets/icons/iconsax/record-circle.svg";
export const iconsaxReceived = "/assets/icons/iconsax/received.svg";
export const iconsaxReceiveSquare = "/assets/icons/iconsax/receive-square.svg";
export const iconsaxReceiveSquare2 = "/assets/icons/iconsax/receive-square-2.svg";
export const iconsaxReceipt = "/assets/icons/iconsax/receipt.svg";
export const iconsaxReceiptText = "/assets/icons/iconsax/receipt-text.svg";
export const iconsaxReceiptSquare = "/assets/icons/iconsax/receipt-square.svg";
export const iconsaxReceiptSearch = "/assets/icons/iconsax/receipt-search.svg";
export const iconsaxReceiptMinus = "/assets/icons/iconsax/receipt-minus.svg";
export const iconsaxReceiptItem = "/assets/icons/iconsax/receipt-item.svg";
export const iconsaxReceiptEdit = "/assets/icons/iconsax/receipt-edit.svg";
export const iconsaxReceiptDisscount = "/assets/icons/iconsax/receipt-disscount.svg";
export const iconsaxReceiptDiscount = "/assets/icons/iconsax/receipt-discount.svg";
export const iconsaxReceiptAdd = "/assets/icons/iconsax/receipt-add.svg";
export const iconsaxReceipt2 = "/assets/icons/iconsax/receipt-2.svg";
export const iconsaxReceipt21 = "/assets/icons/iconsax/receipt-2-1.svg";
export const iconsaxReceipt1 = "/assets/icons/iconsax/receipt-1.svg";
export const iconsaxRanking = "/assets/icons/iconsax/ranking.svg";
export const iconsaxRanking1 = "/assets/icons/iconsax/ranking-1.svg";
export const iconsaxRam = "/assets/icons/iconsax/ram.svg";
export const iconsaxRam2 = "/assets/icons/iconsax/ram-2.svg";
export const iconsaxRadio = "/assets/icons/iconsax/radio.svg";
export const iconsaxRadar = "/assets/icons/iconsax/radar.svg";
export const iconsaxRadar2 = "/assets/icons/iconsax/radar-2.svg";
export const iconsaxRadar1 = "/assets/icons/iconsax/radar-1.svg";
export const iconsaxQuoteUp = "/assets/icons/iconsax/quote-up.svg";
export const iconsaxQuoteUpSquare = "/assets/icons/iconsax/quote-up-square.svg";
export const iconsaxQuoteUpCircle = "/assets/icons/iconsax/quote-up-circle.svg";
export const iconsaxQuoteDown = "/assets/icons/iconsax/quote-down.svg";
export const iconsaxQuoteDownSquare = "/assets/icons/iconsax/quote-down-square.svg";
export const iconsaxQuoteDownCircle = "/assets/icons/iconsax/quote-down-circle.svg";
export const iconsaxProgrammingArrows = "/assets/icons/iconsax/programming-arrows.svg";
export const iconsaxProgrammingArrow = "/assets/icons/iconsax/programming-arrow.svg";
export const iconsaxProfile = "/assets/icons/iconsax/profile.svg";
export const iconsaxProfileTick = "/assets/icons/iconsax/profile-tick.svg";
export const iconsaxProfileRemove = "/assets/icons/iconsax/profile-remove.svg";
export const iconsaxProfileDelete = "/assets/icons/iconsax/profile-delete.svg";
export const iconsaxProfileCircle = "/assets/icons/iconsax/profile-circle.svg";
export const iconsaxProfileAdd = "/assets/icons/iconsax/profile-add.svg";
export const iconsaxProfile2user = "/assets/icons/iconsax/profile-2user.svg";
export const iconsaxPrinter = "/assets/icons/iconsax/printer.svg";
export const iconsaxPrinterSlash = "/assets/icons/iconsax/printer-slash.svg";
export const iconsaxPrevious = "/assets/icons/iconsax/previous.svg";
export const iconsaxPresentionChart = "/assets/icons/iconsax/presention-chart.svg";
export const iconsaxPlay = "/assets/icons/iconsax/play.svg";
export const iconsaxPlayRemove = "/assets/icons/iconsax/play-remove.svg";
export const iconsaxPlayCricle = "/assets/icons/iconsax/play-cricle.svg";
export const iconsaxPlayCircle = "/assets/icons/iconsax/play-circle.svg";
export const iconsaxPlayAdd = "/assets/icons/iconsax/play-add.svg";
export const iconsaxPinterest = "/assets/icons/iconsax/pinterest.svg";
export const iconsaxPictureFrame = "/assets/icons/iconsax/picture-frame.svg";
export const iconsaxPharagraphspacing = "/assets/icons/iconsax/pharagraphspacing.svg";
export const iconsaxPet = "/assets/icons/iconsax/pet.svg";
export const iconsaxPersonalcard = "/assets/icons/iconsax/personalcard.svg";
export const iconsaxPercentageSquare = "/assets/icons/iconsax/percentage-square.svg";
export const iconsaxPeople = "/assets/icons/iconsax/people.svg";
export const iconsaxPenTool = "/assets/icons/iconsax/pen-tool.svg";
export const iconsaxPenTool2 = "/assets/icons/iconsax/pen-tool-2.svg";
export const iconsaxPenTool21 = "/assets/icons/iconsax/pen-tool-2-1.svg";
export const iconsaxPenTool1 = "/assets/icons/iconsax/pen-tool-1.svg";
export const iconsaxPenRemove = "/assets/icons/iconsax/pen-remove.svg";
export const iconsaxPenRemove1 = "/assets/icons/iconsax/pen-remove-1.svg";
export const iconsaxPenClose = "/assets/icons/iconsax/pen-close.svg";
export const iconsaxPenClose1 = "/assets/icons/iconsax/pen-close-1.svg";
export const iconsaxPenAdd = "/assets/icons/iconsax/pen-add.svg";
export const iconsaxPenAdd1 = "/assets/icons/iconsax/pen-add-1.svg";
export const iconsaxPause = "/assets/icons/iconsax/pause.svg";
export const iconsaxPauseCircle = "/assets/icons/iconsax/pause-circle.svg";
export const iconsaxPath = "/assets/icons/iconsax/path.svg";
export const iconsaxPathSquare = "/assets/icons/iconsax/path-square.svg";
export const iconsaxPath2 = "/assets/icons/iconsax/path-2.svg";
export const iconsaxPasswordCheck = "/assets/icons/iconsax/password-check.svg";
export const iconsaxPaperclip = "/assets/icons/iconsax/paperclip.svg";
export const iconsaxPaperclip2 = "/assets/icons/iconsax/paperclip-2.svg";
export const iconsaxPaintbucket = "/assets/icons/iconsax/paintbucket.svg";
export const iconsaxOmegaSquare = "/assets/icons/iconsax/omega-square.svg";
export const iconsaxOmegaSquare1 = "/assets/icons/iconsax/omega-square-1.svg";
export const iconsaxOmegaCircle = "/assets/icons/iconsax/omega-circle.svg";
export const iconsaxOmegaCircle1 = "/assets/icons/iconsax/omega-circle-1.svg";
export const iconsaxNotification = "/assets/icons/iconsax/notification.svg";
export const iconsaxNotificationStatus = "/assets/icons/iconsax/notification-status.svg";
export const iconsaxNotificationFavorite = "/assets/icons/iconsax/notification-favorite.svg";
export const iconsaxNotificationCircle = "/assets/icons/iconsax/notification-circle.svg";
export const iconsaxNotificationBing = "/assets/icons/iconsax/notification-bing.svg";
export const iconsaxNotification1 = "/assets/icons/iconsax/notification-1.svg";
export const iconsaxNote = "/assets/icons/iconsax/note.svg";
export const iconsaxNoteText = "/assets/icons/iconsax/note-text.svg";
export const iconsaxNoteSquare = "/assets/icons/iconsax/note-square.svg";
export const iconsaxNoteRemove = "/assets/icons/iconsax/note-remove.svg";
export const iconsaxNoteFavorite = "/assets/icons/iconsax/note-favorite.svg";
export const iconsaxNoteAdd = "/assets/icons/iconsax/note-add.svg";
export const iconsaxNote21 = "/assets/icons/iconsax/note-21.svg";
export const iconsaxNote2 = "/assets/icons/iconsax/note-2.svg";
export const iconsaxNote1 = "/assets/icons/iconsax/note-1.svg";
export const iconsaxNext = "/assets/icons/iconsax/next.svg";
export const iconsaxMusicnote = "/assets/icons/iconsax/musicnote.svg";
export const iconsaxMusic = "/assets/icons/iconsax/music.svg";
export const iconsaxMusicSquare = "/assets/icons/iconsax/music-square.svg";
export const iconsaxMusicSquareSearch = "/assets/icons/iconsax/music-square-search.svg";
export const iconsaxMusicSquareRemove = "/assets/icons/iconsax/music-square-remove.svg";
export const iconsaxMusicSquareAdd = "/assets/icons/iconsax/music-square-add.svg";
export const iconsaxMusicPlaylist = "/assets/icons/iconsax/music-playlist.svg";
export const iconsaxMusicPlay = "/assets/icons/iconsax/music-play.svg";
export const iconsaxMusicLibrary2 = "/assets/icons/iconsax/music-library-2.svg";
export const iconsaxMusicFilter = "/assets/icons/iconsax/music-filter.svg";
export const iconsaxMusicDashboard = "/assets/icons/iconsax/music-dashboard.svg";
export const iconsaxMusicCircle = "/assets/icons/iconsax/music-circle.svg";
export const iconsaxMouse = "/assets/icons/iconsax/mouse.svg";
export const iconsaxMouseSquare = "/assets/icons/iconsax/mouse-square.svg";
export const iconsaxMouseCircle = "/assets/icons/iconsax/mouse-circle.svg";
export const iconsaxMouse1 = "/assets/icons/iconsax/mouse-1.svg";
export const iconsaxMore = "/assets/icons/iconsax/more.svg";
export const iconsaxMoreSquare = "/assets/icons/iconsax/more-square.svg";
export const iconsaxMoreCircle = "/assets/icons/iconsax/more-circle.svg";
export const iconsaxMore2 = "/assets/icons/iconsax/more-2.svg";
export const iconsaxMoon = "/assets/icons/iconsax/moon.svg";
export const iconsaxMonitor = "/assets/icons/iconsax/monitor.svg";
export const iconsaxMonitorRecorder = "/assets/icons/iconsax/monitor-recorder.svg";
export const iconsaxMonitorMobbile = "/assets/icons/iconsax/monitor-mobbile.svg";
export const iconsaxMoneys = "/assets/icons/iconsax/moneys.svg";
export const iconsaxMoney = "/assets/icons/iconsax/money.svg";
export const iconsaxMoneyTime = "/assets/icons/iconsax/money-time.svg";
export const iconsaxMoneyTick = "/assets/icons/iconsax/money-tick.svg";
export const iconsaxMoneySend = "/assets/icons/iconsax/money-send.svg";
export const iconsaxMoneyRemove = "/assets/icons/iconsax/money-remove.svg";
export const iconsaxMoneyRecive = "/assets/icons/iconsax/money-recive.svg";
export const iconsaxMoneyForbidden = "/assets/icons/iconsax/money-forbidden.svg";
export const iconsaxMoneyChange = "/assets/icons/iconsax/money-change.svg";
export const iconsaxMoneyAdd = "/assets/icons/iconsax/money-add.svg";
export const iconsaxMoney4 = "/assets/icons/iconsax/money-4.svg";
export const iconsaxMoney3 = "/assets/icons/iconsax/money-3.svg";
export const iconsaxMoney2 = "/assets/icons/iconsax/money-2.svg";
export const iconsaxMobile = "/assets/icons/iconsax/mobile.svg";
export const iconsaxMobileProgramming = "/assets/icons/iconsax/mobile-programming.svg";
export const iconsaxMirroringScreen = "/assets/icons/iconsax/mirroring-screen.svg";
export const iconsaxMirror = "/assets/icons/iconsax/mirror.svg";
export const iconsaxMinus = "/assets/icons/iconsax/minus.svg";
export const iconsaxMinusSquare = "/assets/icons/iconsax/minus-square.svg";
export const iconsaxMinusCirlce = "/assets/icons/iconsax/minus-cirlce.svg";
export const iconsaxMiniMusicSqaure = "/assets/icons/iconsax/mini-music-sqaure.svg";
export const iconsaxMilk = "/assets/icons/iconsax/milk.svg";
export const iconsaxMicroscope = "/assets/icons/iconsax/microscope.svg";
export const iconsaxMicrophone = "/assets/icons/iconsax/microphone.svg";
export const iconsaxMicrophoneSlash = "/assets/icons/iconsax/microphone-slash.svg";
export const iconsaxMicrophoneSlash1 = "/assets/icons/iconsax/microphone-slash-1.svg";
export const iconsaxMicrophone2 = "/assets/icons/iconsax/microphone-2.svg";
export const iconsaxMessages = "/assets/icons/iconsax/messages.svg";
export const iconsaxMessages3 = "/assets/icons/iconsax/messages-3.svg";
export const iconsaxMessages2 = "/assets/icons/iconsax/messages-2.svg";
export const iconsaxMessages1 = "/assets/icons/iconsax/messages-1.svg";
export const iconsaxMessage = "/assets/icons/iconsax/message.svg";
export const iconsaxMessageTime = "/assets/icons/iconsax/message-time.svg";
export const iconsaxMessageTick = "/assets/icons/iconsax/message-tick.svg";
export const iconsaxMessageText = "/assets/icons/iconsax/message-text.svg";
export const iconsaxMessageText1 = "/assets/icons/iconsax/message-text-1.svg";
export const iconsaxMessageSquare = "/assets/icons/iconsax/message-square.svg";
export const iconsaxMessageSearch = "/assets/icons/iconsax/message-search.svg";
export const iconsaxMessageRemove = "/assets/icons/iconsax/message-remove.svg";
export const iconsaxMessageQuestion = "/assets/icons/iconsax/message-question.svg";
export const iconsaxMessageProgramming = "/assets/icons/iconsax/message-programming.svg";
export const iconsaxMessageNotif = "/assets/icons/iconsax/message-notif.svg";
export const iconsaxMessageMinus = "/assets/icons/iconsax/message-minus.svg";
export const iconsaxMessageFavorite = "/assets/icons/iconsax/message-favorite.svg";
export const iconsaxMessageEdit = "/assets/icons/iconsax/message-edit.svg";
export const iconsaxMessageCircle = "/assets/icons/iconsax/message-circle.svg";
export const iconsaxMessageAdd = "/assets/icons/iconsax/message-add.svg";
export const iconsaxMessageAdd1 = "/assets/icons/iconsax/message-add-1.svg";
export const iconsaxMessage2 = "/assets/icons/iconsax/message-2.svg";
export const iconsaxMenu = "/assets/icons/iconsax/menu.svg";
export const iconsaxMenuBoard = "/assets/icons/iconsax/menu-board.svg";
export const iconsaxMenu1 = "/assets/icons/iconsax/menu-1.svg";
export const iconsaxMedal = "/assets/icons/iconsax/medal.svg";
export const iconsaxMedalStar = "/assets/icons/iconsax/medal-star.svg";
export const iconsaxMaximize = "/assets/icons/iconsax/maximize.svg";
export const iconsaxMaximizeCircle = "/assets/icons/iconsax/maximize-circle.svg";
export const iconsaxMaximize4 = "/assets/icons/iconsax/maximize-4.svg";
export const iconsaxMaximize3 = "/assets/icons/iconsax/maximize-3.svg";
export const iconsaxMaximize21 = "/assets/icons/iconsax/maximize-21.svg";
export const iconsaxMaximize2 = "/assets/icons/iconsax/maximize-2.svg";
export const iconsaxMaximize1 = "/assets/icons/iconsax/maximize-1.svg";
export const iconsaxMath = "/assets/icons/iconsax/math.svg";
export const iconsaxMask = "/assets/icons/iconsax/mask.svg";
export const iconsaxMask3 = "/assets/icons/iconsax/mask-3.svg";
export const iconsaxMask2 = "/assets/icons/iconsax/mask-2.svg";
export const iconsaxMask1 = "/assets/icons/iconsax/mask-1.svg";
export const iconsaxMap = "/assets/icons/iconsax/map.svg";
export const iconsaxMap1 = "/assets/icons/iconsax/map-1.svg";
export const iconsaxMan = "/assets/icons/iconsax/man.svg";
export const iconsaxMainComponent = "/assets/icons/iconsax/main-component.svg";
export const iconsaxMainComponent1 = "/assets/icons/iconsax/main-component-1.svg";
export const iconsaxMagicpen = "/assets/icons/iconsax/magicpen.svg";
export const iconsaxMagicStar = "/assets/icons/iconsax/magic-star.svg";
export const iconsaxLovely = "/assets/icons/iconsax/lovely.svg";
export const iconsaxLogout = "/assets/icons/iconsax/logout.svg";
export const iconsaxLogout1 = "/assets/icons/iconsax/logout-1.svg";
export const iconsaxLogin = "/assets/icons/iconsax/login.svg";
export const iconsaxLogin1 = "/assets/icons/iconsax/login-1.svg";
export const iconsaxLock = "/assets/icons/iconsax/lock.svg";
export const iconsaxLockSlash = "/assets/icons/iconsax/lock-slash.svg";
export const iconsaxLockCircle = "/assets/icons/iconsax/lock-circle.svg";
export const iconsaxLock1 = "/assets/icons/iconsax/lock-1.svg";
export const iconsaxLocation = "/assets/icons/iconsax/location.svg";
export const iconsaxLocationTick = "/assets/icons/iconsax/location-tick.svg";
export const iconsaxLocationSlash = "/assets/icons/iconsax/location-slash.svg";
export const iconsaxLocationMinus = "/assets/icons/iconsax/location-minus.svg";
export const iconsaxLocationCross = "/assets/icons/iconsax/location-cross.svg";
export const iconsaxLocationAdd = "/assets/icons/iconsax/location-add.svg";
export const iconsaxLink = "/assets/icons/iconsax/link.svg";
export const iconsaxLinkSquare = "/assets/icons/iconsax/link-square.svg";
export const iconsaxLinkCircle = "/assets/icons/iconsax/link-circle.svg";
export const iconsaxLink21 = "/assets/icons/iconsax/link-21.svg";
export const iconsaxLink2 = "/assets/icons/iconsax/link-2.svg";
export const iconsaxLink1 = "/assets/icons/iconsax/link-1.svg";
export const iconsaxLike = "/assets/icons/iconsax/like.svg";
export const iconsaxLikeTag = "/assets/icons/iconsax/like-tag.svg";
export const iconsaxLikeShapes = "/assets/icons/iconsax/like-shapes.svg";
export const iconsaxLikeDislike = "/assets/icons/iconsax/like-dislike.svg";
export const iconsaxLike1 = "/assets/icons/iconsax/like-1.svg";
export const iconsaxLifebuoy = "/assets/icons/iconsax/lifebuoy.svg";
export const iconsaxLevel = "/assets/icons/iconsax/level.svg";
export const iconsaxLayer = "/assets/icons/iconsax/layer.svg";
export const iconsaxLanguageSquare = "/assets/icons/iconsax/language-square.svg";
export const iconsaxLanguageCircle = "/assets/icons/iconsax/language-circle.svg";
export const iconsaxLamp = "/assets/icons/iconsax/lamp.svg";
export const iconsaxLampSlash = "/assets/icons/iconsax/lamp-slash.svg";
export const iconsaxLampOn = "/assets/icons/iconsax/lamp-on.svg";
export const iconsaxLampCharge = "/assets/icons/iconsax/lamp-charge.svg";
export const iconsaxLamp1 = "/assets/icons/iconsax/lamp-1.svg";
export const iconsaxKeyboard = "/assets/icons/iconsax/keyboard.svg";
export const iconsaxKeyboardOpen = "/assets/icons/iconsax/keyboard-open.svg";
export const iconsaxKey = "/assets/icons/iconsax/key.svg";
export const iconsaxKeySquare = "/assets/icons/iconsax/key-square.svg";
export const iconsaxKanban = "/assets/icons/iconsax/kanban.svg";
export const iconsaxJudge = "/assets/icons/iconsax/judge.svg";
export const iconsaxInstagram = "/assets/icons/iconsax/instagram.svg";
export const iconsaxInformation = "/assets/icons/iconsax/information.svg";
export const iconsaxInfoCircle = "/assets/icons/iconsax/info-circle.svg";
export const iconsaxImport = "/assets/icons/iconsax/import.svg";
export const iconsaxImport2 = "/assets/icons/iconsax/import-2.svg";
export const iconsaxImport1 = "/assets/icons/iconsax/import-1.svg";
export const iconsaxImage = "/assets/icons/iconsax/image.svg";
export const iconsaxHouse = "/assets/icons/iconsax/house.svg";
export const iconsaxHouse2 = "/assets/icons/iconsax/house-2.svg";
export const iconsaxHospital = "/assets/icons/iconsax/hospital.svg";
export const iconsaxHome = "/assets/icons/iconsax/home.svg";
export const iconsaxHomeWifi = "/assets/icons/iconsax/home-wifi.svg";
export const iconsaxHomeTrendUp = "/assets/icons/iconsax/home-trend-up.svg";
export const iconsaxHomeTrendDown = "/assets/icons/iconsax/home-trend-down.svg";
export const iconsaxHomeHashtag = "/assets/icons/iconsax/home-hashtag.svg";
export const iconsaxHome2 = "/assets/icons/iconsax/home-2.svg";
export const iconsaxHierarchy = "/assets/icons/iconsax/hierarchy.svg";
export const iconsaxHierarchySquare = "/assets/icons/iconsax/hierarchy-square.svg";
export const iconsaxHierarchySquare3 = "/assets/icons/iconsax/hierarchy-square-3.svg";
export const iconsaxHierarchySquare2 = "/assets/icons/iconsax/hierarchy-square-2.svg";
export const iconsaxHierarchy3 = "/assets/icons/iconsax/hierarchy-3.svg";
export const iconsaxHierarchy2 = "/assets/icons/iconsax/hierarchy-2.svg";
export const iconsaxHeart = "/assets/icons/iconsax/heart.svg";
export const iconsaxHeartTick = "/assets/icons/iconsax/heart-tick.svg";
export const iconsaxHeartSlash = "/assets/icons/iconsax/heart-slash.svg";
export const iconsaxHeartSearch = "/assets/icons/iconsax/heart-search.svg";
export const iconsaxHeartRemove = "/assets/icons/iconsax/heart-remove.svg";
export const iconsaxHeartEdit = "/assets/icons/iconsax/heart-edit.svg";
export const iconsaxHeartCircle = "/assets/icons/iconsax/heart-circle.svg";
export const iconsaxHeartAdd = "/assets/icons/iconsax/heart-add.svg";
export const iconsaxHealth = "/assets/icons/iconsax/health.svg";
export const iconsaxHeadphones = "/assets/icons/iconsax/headphones.svg";
export const iconsaxHeadphone = "/assets/icons/iconsax/headphone.svg";
export const iconsaxHashtag = "/assets/icons/iconsax/hashtag.svg";
export const iconsaxHashtagUp = "/assets/icons/iconsax/hashtag-up.svg";
export const iconsaxHashtagDown = "/assets/icons/iconsax/hashtag-down.svg";
export const iconsaxHashtag1 = "/assets/icons/iconsax/hashtag-1.svg";
export const iconsaxHappyemoji = "/assets/icons/iconsax/happyemoji.svg";
export const iconsaxGroup = "/assets/icons/iconsax/group.svg";
export const iconsaxGroup9 = "/assets/icons/iconsax/group-9.svg";
export const iconsaxGroup8 = "/assets/icons/iconsax/group-8.svg";
export const iconsaxGroup7 = "/assets/icons/iconsax/group-7.svg";
export const iconsaxGroup6 = "/assets/icons/iconsax/group-6.svg";
export const iconsaxGroup5 = "/assets/icons/iconsax/group-5.svg";
export const iconsaxGroup4 = "/assets/icons/iconsax/group-4.svg";
export const iconsaxGroup3 = "/assets/icons/iconsax/group-3.svg";
export const iconsaxGroup2 = "/assets/icons/iconsax/group-2.svg";
export const iconsaxGroup11 = "/assets/icons/iconsax/group-11.svg";
export const iconsaxGroup10 = "/assets/icons/iconsax/group-10.svg";
export const iconsaxGroup1 = "/assets/icons/iconsax/group-1.svg";
export const iconsaxGridLock = "/assets/icons/iconsax/grid-lock.svg";
export const iconsaxGridEraser = "/assets/icons/iconsax/grid-eraser.svg";
export const iconsaxGridEdit = "/assets/icons/iconsax/grid-edit.svg";
export const iconsaxGrid9 = "/assets/icons/iconsax/grid-9.svg";
export const iconsaxGrid8 = "/assets/icons/iconsax/grid-8.svg";
export const iconsaxGrid7 = "/assets/icons/iconsax/grid-7.svg";
export const iconsaxGrid6 = "/assets/icons/iconsax/grid-6.svg";
export const iconsaxGrid5 = "/assets/icons/iconsax/grid-5.svg";
export const iconsaxGrid4 = "/assets/icons/iconsax/grid-4.svg";
export const iconsaxGrid3 = "/assets/icons/iconsax/grid-3.svg";
export const iconsaxGrid2 = "/assets/icons/iconsax/grid-2.svg";
export const iconsaxGrid1 = "/assets/icons/iconsax/grid-1.svg";
export const iconsaxGraph = "/assets/icons/iconsax/graph.svg";
export const iconsaxGrammerly = "/assets/icons/iconsax/grammerly.svg";
export const iconsaxGps = "/assets/icons/iconsax/gps.svg";
export const iconsaxGpsSlash = "/assets/icons/iconsax/gps-slash.svg";
export const iconsaxGlobal = "/assets/icons/iconsax/global.svg";
export const iconsaxGlobalSearch = "/assets/icons/iconsax/global-search.svg";
export const iconsaxGlobalRefresh = "/assets/icons/iconsax/global-refresh.svg";
export const iconsaxGlobalEdit = "/assets/icons/iconsax/global-edit.svg";
export const iconsaxGlass = "/assets/icons/iconsax/glass.svg";
export const iconsaxGlass1 = "/assets/icons/iconsax/glass-1.svg";
export const iconsaxGift = "/assets/icons/iconsax/gift.svg";
export const iconsaxGhost = "/assets/icons/iconsax/ghost.svg";
export const iconsaxGemini = "/assets/icons/iconsax/gemini.svg";
export const iconsaxGemini2 = "/assets/icons/iconsax/gemini-2.svg";
export const iconsaxGasStation = "/assets/icons/iconsax/gas-station.svg";
export const iconsaxGameboy = "/assets/icons/iconsax/gameboy.svg";
export const iconsaxGame = "/assets/icons/iconsax/game.svg";
export const iconsaxGallery = "/assets/icons/iconsax/gallery.svg";
export const iconsaxGalleryTick = "/assets/icons/iconsax/gallery-tick.svg";
export const iconsaxGallerySlash = "/assets/icons/iconsax/gallery-slash.svg";
export const iconsaxGalleryRemove = "/assets/icons/iconsax/gallery-remove.svg";
export const iconsaxGalleryImport = "/assets/icons/iconsax/gallery-import.svg";
export const iconsaxGalleryFavorite = "/assets/icons/iconsax/gallery-favorite.svg";
export const iconsaxGalleryExport = "/assets/icons/iconsax/gallery-export.svg";
export const iconsaxGalleryEdit = "/assets/icons/iconsax/gallery-edit.svg";
export const iconsaxGalleryAdd = "/assets/icons/iconsax/gallery-add.svg";
export const iconsaxFrame = "/assets/icons/iconsax/frame.svg";
export const iconsaxFrame5 = "/assets/icons/iconsax/frame-5.svg";
export const iconsaxFrame4 = "/assets/icons/iconsax/frame-4.svg";
export const iconsaxFrame3 = "/assets/icons/iconsax/frame-3.svg";
export const iconsaxFrame2 = "/assets/icons/iconsax/frame-2.svg";
export const iconsaxFrame1 = "/assets/icons/iconsax/frame-1.svg";
export const iconsaxForward = "/assets/icons/iconsax/forward.svg";
export const iconsaxForwardSquare = "/assets/icons/iconsax/forward-square.svg";
export const iconsaxForwardItem = "/assets/icons/iconsax/forward-item.svg";
export const iconsaxForwardItem1 = "/assets/icons/iconsax/forward-item-1.svg";
export const iconsaxForward5Seconds = "/assets/icons/iconsax/forward-5-seconds.svg";
export const iconsaxForward15Seconds = "/assets/icons/iconsax/forward-15-seconds.svg";
export const iconsaxForward10Seconds = "/assets/icons/iconsax/forward-10-seconds.svg";
export const iconsaxFormatSquare = "/assets/icons/iconsax/format-square.svg";
export const iconsaxFormatCircle = "/assets/icons/iconsax/format-circle.svg";
export const iconsaxFolder = "/assets/icons/iconsax/folder.svg";
export const iconsaxFolderOpen = "/assets/icons/iconsax/folder-open.svg";
export const iconsaxFolderMinus = "/assets/icons/iconsax/folder-minus.svg";
export const iconsaxFolderFavorite = "/assets/icons/iconsax/folder-favorite.svg";
export const iconsaxFolderCross = "/assets/icons/iconsax/folder-cross.svg";
export const iconsaxFolderConnection = "/assets/icons/iconsax/folder-connection.svg";
export const iconsaxFolderCloud = "/assets/icons/iconsax/folder-cloud.svg";
export const iconsaxFolderAdd = "/assets/icons/iconsax/folder-add.svg";
export const iconsaxFolder2 = "/assets/icons/iconsax/folder-2.svg";
export const iconsaxFlash = "/assets/icons/iconsax/flash.svg";
export const iconsaxFlashSlash = "/assets/icons/iconsax/flash-slash.svg";
export const iconsaxFlashCircle = "/assets/icons/iconsax/flash-circle.svg";
export const iconsaxFlashCircle2 = "/assets/icons/iconsax/flash-circle-2.svg";
export const iconsaxFlashCircle1 = "/assets/icons/iconsax/flash-circle-1.svg";
export const iconsaxFlash1 = "/assets/icons/iconsax/flash-1.svg";
export const iconsaxFlag = "/assets/icons/iconsax/flag.svg";
export const iconsaxFlag2 = "/assets/icons/iconsax/flag-2.svg";
export const iconsaxFirstline = "/assets/icons/iconsax/firstline.svg";
export const iconsaxFingerScan = "/assets/icons/iconsax/finger-scan.svg";
export const iconsaxFingerCricle = "/assets/icons/iconsax/finger-cricle.svg";
export const iconsaxFilter = "/assets/icons/iconsax/filter.svg";
export const iconsaxFilterTick = "/assets/icons/iconsax/filter-tick.svg";
export const iconsaxFilterSquare = "/assets/icons/iconsax/filter-square.svg";
export const iconsaxFilterSearch = "/assets/icons/iconsax/filter-search.svg";
export const iconsaxFilterRemove = "/assets/icons/iconsax/filter-remove.svg";
export const iconsaxFilterEdit = "/assets/icons/iconsax/filter-edit.svg";
export const iconsaxFilterAdd = "/assets/icons/iconsax/filter-add.svg";
export const iconsaxFavoriteChart = "/assets/icons/iconsax/favorite-chart.svg";
export const iconsaxFatrows = "/assets/icons/iconsax/fatrows.svg";
export const iconsaxFacebook = "/assets/icons/iconsax/facebook.svg";
export const iconsaxEye = "/assets/icons/iconsax/eye.svg";
export const iconsaxEyeSlash = "/assets/icons/iconsax/eye-slash.svg";
export const iconsaxExternalDrive = "/assets/icons/iconsax/external-drive.svg";
export const iconsaxExport = "/assets/icons/iconsax/export.svg";
export const iconsaxExport3 = "/assets/icons/iconsax/export-3.svg";
export const iconsaxExport2 = "/assets/icons/iconsax/export-2.svg";
export const iconsaxExport1 = "/assets/icons/iconsax/export-1.svg";
export const iconsaxEraser = "/assets/icons/iconsax/eraser.svg";
export const iconsaxEraser2 = "/assets/icons/iconsax/eraser-2.svg";
export const iconsaxEraser1 = "/assets/icons/iconsax/eraser-1.svg";
export const iconsaxEmptyWallet = "/assets/icons/iconsax/empty-wallet.svg";
export const iconsaxEmptyWalletTime = "/assets/icons/iconsax/empty-wallet-time.svg";
export const iconsaxEmptyWalletTick = "/assets/icons/iconsax/empty-wallet-tick.svg";
export const iconsaxEmptyWalletRemove = "/assets/icons/iconsax/empty-wallet-remove.svg";
export const iconsaxEmptyWalletChange = "/assets/icons/iconsax/empty-wallet-change.svg";
export const iconsaxEmptyWalletAdd = "/assets/icons/iconsax/empty-wallet-add.svg";
export const iconsaxEmojiSad = "/assets/icons/iconsax/emoji-sad.svg";
export const iconsaxEmojiNormal = "/assets/icons/iconsax/emoji-normal.svg";
export const iconsaxEmojiHappy = "/assets/icons/iconsax/emoji-happy.svg";
export const iconsaxElementPlus = "/assets/icons/iconsax/element-plus.svg";
export const iconsaxElementEqual = "/assets/icons/iconsax/element-equal.svg";
export const iconsaxElement4 = "/assets/icons/iconsax/element-4.svg";
export const iconsaxElement3 = "/assets/icons/iconsax/element-3.svg";
export const iconsaxElement2 = "/assets/icons/iconsax/element-2.svg";
export const iconsaxElement1 = "/assets/icons/iconsax/element-1.svg";
export const iconsaxElectricity = "/assets/icons/iconsax/electricity.svg";
export const iconsaxEdit = "/assets/icons/iconsax/edit.svg";
export const iconsaxEdit2 = "/assets/icons/iconsax/edit-2.svg";
export const iconsaxDrop = "/assets/icons/iconsax/drop.svg";
export const iconsaxDriving = "/assets/icons/iconsax/driving.svg";
export const iconsaxDriver = "/assets/icons/iconsax/driver.svg";
export const iconsaxDriverRefresh = "/assets/icons/iconsax/driver-refresh.svg";
export const iconsaxDriver2 = "/assets/icons/iconsax/driver-2.svg";
export const iconsaxDollarSquare = "/assets/icons/iconsax/dollar-square.svg";
export const iconsaxDollarCircle = "/assets/icons/iconsax/dollar-circle.svg";
export const iconsaxDocument = "/assets/icons/iconsax/document.svg";
export const iconsaxDocumentUpload = "/assets/icons/iconsax/document-upload.svg";
export const iconsaxDocumentText = "/assets/icons/iconsax/document-text.svg";
export const iconsaxDocumentText1 = "/assets/icons/iconsax/document-text-1.svg";
export const iconsaxDocumentSketch = "/assets/icons/iconsax/document-sketch.svg";
export const iconsaxDocumentPrevious = "/assets/icons/iconsax/document-previous.svg";
export const iconsaxDocumentNormal = "/assets/icons/iconsax/document-normal.svg";
export const iconsaxDocumentLike = "/assets/icons/iconsax/document-like.svg";
export const iconsaxDocumentForward = "/assets/icons/iconsax/document-forward.svg";
export const iconsaxDocumentFilter = "/assets/icons/iconsax/document-filter.svg";
export const iconsaxDocumentFavorite = "/assets/icons/iconsax/document-favorite.svg";
export const iconsaxDocumentDownload = "/assets/icons/iconsax/document-download.svg";
export const iconsaxDocumentCopy = "/assets/icons/iconsax/document-copy.svg";
export const iconsaxDocumentCode = "/assets/icons/iconsax/document-code.svg";
export const iconsaxDocumentCode2 = "/assets/icons/iconsax/document-code-2.svg";
export const iconsaxDocumentCloud = "/assets/icons/iconsax/document-cloud.svg";
export const iconsaxDocument1 = "/assets/icons/iconsax/document-1.svg";
export const iconsaxDislike = "/assets/icons/iconsax/dislike.svg";
export const iconsaxDiscover = "/assets/icons/iconsax/discover.svg";
export const iconsaxDiscover1 = "/assets/icons/iconsax/discover-1.svg";
export const iconsaxDiscountShape = "/assets/icons/iconsax/discount-shape.svg";
export const iconsaxDiscountCircle = "/assets/icons/iconsax/discount-circle.svg";
export const iconsaxDirectboxSend = "/assets/icons/iconsax/directbox-send.svg";
export const iconsaxDirectboxReceive = "/assets/icons/iconsax/directbox-receive.svg";
export const iconsaxDirectboxNotif = "/assets/icons/iconsax/directbox-notif.svg";
export const iconsaxDirectboxDefault = "/assets/icons/iconsax/directbox-default.svg";
export const iconsaxDirect = "/assets/icons/iconsax/direct.svg";
export const iconsaxDirectUp = "/assets/icons/iconsax/direct-up.svg";
export const iconsaxDirectSend = "/assets/icons/iconsax/direct-send.svg";
export const iconsaxDirectRight = "/assets/icons/iconsax/direct-right.svg";
export const iconsaxDirectNotification = "/assets/icons/iconsax/direct-notification.svg";
export const iconsaxDirectNormal = "/assets/icons/iconsax/direct-normal.svg";
export const iconsaxDirectLeft = "/assets/icons/iconsax/direct-left.svg";
export const iconsaxDirectInbox = "/assets/icons/iconsax/direct-inbox.svg";
export const iconsaxDirectDown = "/assets/icons/iconsax/direct-down.svg";
export const iconsaxDiamonds = "/assets/icons/iconsax/diamonds.svg";
export const iconsaxDiagram = "/assets/icons/iconsax/diagram.svg";
export const iconsaxDevices = "/assets/icons/iconsax/devices.svg";
export const iconsaxDevices1 = "/assets/icons/iconsax/devices-1.svg";
export const iconsaxDeviceMessage = "/assets/icons/iconsax/device-message.svg";
export const iconsaxDesigntools = "/assets/icons/iconsax/designtools.svg";
export const iconsaxData = "/assets/icons/iconsax/data.svg";
export const iconsaxData2 = "/assets/icons/iconsax/data-2.svg";
export const iconsaxDanger = "/assets/icons/iconsax/danger.svg";
export const iconsaxCup = "/assets/icons/iconsax/cup.svg";
export const iconsaxCrown = "/assets/icons/iconsax/crown.svg";
export const iconsaxCrown1 = "/assets/icons/iconsax/crown-1.svg";
export const iconsaxCrop = "/assets/icons/iconsax/crop.svg";
export const iconsaxCreativeCommons = "/assets/icons/iconsax/creative-commons.svg";
export const iconsaxCpu = "/assets/icons/iconsax/cpu.svg";
export const iconsaxCpuSetting = "/assets/icons/iconsax/cpu-setting.svg";
export const iconsaxCpuCharge = "/assets/icons/iconsax/cpu-charge.svg";
export const iconsaxCourthouse = "/assets/icons/iconsax/courthouse.svg";
export const iconsaxCopyright = "/assets/icons/iconsax/copyright.svg";
export const iconsaxCopy = "/assets/icons/iconsax/copy.svg";
export const iconsaxCopySuccess = "/assets/icons/iconsax/copy-success.svg";
export const iconsaxConvertshape = "/assets/icons/iconsax/convertshape.svg";
export const iconsaxConvertshape2 = "/assets/icons/iconsax/convertshape-2.svg";
export const iconsaxConvert = "/assets/icons/iconsax/convert.svg";
export const iconsaxConvert3dCube = "/assets/icons/iconsax/convert-3d-cube.svg";
export const iconsaxComputing = "/assets/icons/iconsax/computing.svg";
export const iconsaxComponent = "/assets/icons/iconsax/component.svg";
export const iconsaxComponent1 = "/assets/icons/iconsax/component-1.svg";
export const iconsaxCommand = "/assets/icons/iconsax/command.svg";
export const iconsaxCommandSquare = "/assets/icons/iconsax/command-square.svg";
export const iconsaxColorsSquare = "/assets/icons/iconsax/colors-square.svg";
export const iconsaxColorsSquare1 = "/assets/icons/iconsax/colors-square-1.svg";
export const iconsaxColorfilter = "/assets/icons/iconsax/colorfilter.svg";
export const iconsaxColorSwatch = "/assets/icons/iconsax/color-swatch.svg";
export const iconsaxCoin = "/assets/icons/iconsax/coin.svg";
export const iconsaxCoin1 = "/assets/icons/iconsax/coin-1.svg";
export const iconsaxCoffee = "/assets/icons/iconsax/coffee.svg";
export const iconsaxCode = "/assets/icons/iconsax/code.svg";
export const iconsaxCodeCircle = "/assets/icons/iconsax/code-circle.svg";
export const iconsaxCode1 = "/assets/icons/iconsax/code-1.svg";
export const iconsaxCloud = "/assets/icons/iconsax/cloud.svg";
export const iconsaxCloudSunny = "/assets/icons/iconsax/cloud-sunny.svg";
export const iconsaxCloudSnow = "/assets/icons/iconsax/cloud-snow.svg";
export const iconsaxCloudRemove = "/assets/icons/iconsax/cloud-remove.svg";
export const iconsaxCloudPlus = "/assets/icons/iconsax/cloud-plus.svg";
export const iconsaxCloudNotif = "/assets/icons/iconsax/cloud-notif.svg";
export const iconsaxCloudMinus = "/assets/icons/iconsax/cloud-minus.svg";
export const iconsaxCloudLightning = "/assets/icons/iconsax/cloud-lightning.svg";
export const iconsaxCloudFog = "/assets/icons/iconsax/cloud-fog.svg";
export const iconsaxCloudDrizzle = "/assets/icons/iconsax/cloud-drizzle.svg";
export const iconsaxCloudCross = "/assets/icons/iconsax/cloud-cross.svg";
export const iconsaxCloudConnection = "/assets/icons/iconsax/cloud-connection.svg";
export const iconsaxCloudChange = "/assets/icons/iconsax/cloud-change.svg";
export const iconsaxCloudAdd = "/assets/icons/iconsax/cloud-add.svg";
export const iconsaxCloseSquare = "/assets/icons/iconsax/close-square.svg";
export const iconsaxCloseCircle = "/assets/icons/iconsax/close-circle.svg";
export const iconsaxClock = "/assets/icons/iconsax/clock.svg";
export const iconsaxClock1 = "/assets/icons/iconsax/clock-1.svg";
export const iconsaxClipboard = "/assets/icons/iconsax/clipboard.svg";
export const iconsaxClipboardTick = "/assets/icons/iconsax/clipboard-tick.svg";
export const iconsaxClipboardText = "/assets/icons/iconsax/clipboard-text.svg";
export const iconsaxClipboardImport = "/assets/icons/iconsax/clipboard-import.svg";
export const iconsaxClipboardExport = "/assets/icons/iconsax/clipboard-export.svg";
export const iconsaxClipboardClose = "/assets/icons/iconsax/clipboard-close.svg";
export const iconsaxChrome = "/assets/icons/iconsax/chrome.svg";
export const iconsaxCheck = "/assets/icons/iconsax/check.svg";
export const iconsaxChart = "/assets/icons/iconsax/chart.svg";
export const iconsaxChartSuccess = "/assets/icons/iconsax/chart-success.svg";
export const iconsaxChartSquare = "/assets/icons/iconsax/chart-square.svg";
export const iconsaxChart3 = "/assets/icons/iconsax/chart-3.svg";
export const iconsaxChart21 = "/assets/icons/iconsax/chart-21.svg";
export const iconsaxChart2 = "/assets/icons/iconsax/chart-2.svg";
export const iconsaxChart1 = "/assets/icons/iconsax/chart-1.svg";
export const iconsaxCd = "/assets/icons/iconsax/cd.svg";
export const iconsaxCategory = "/assets/icons/iconsax/category.svg";
export const iconsaxCategory2 = "/assets/icons/iconsax/category-2.svg";
export const iconsaxCards = "/assets/icons/iconsax/cards.svg";
export const iconsaxCard = "/assets/icons/iconsax/card.svg";
export const iconsaxCardTick = "/assets/icons/iconsax/card-tick.svg";
export const iconsaxCardTick1 = "/assets/icons/iconsax/card-tick-1.svg";
export const iconsaxCardSlash = "/assets/icons/iconsax/card-slash.svg";
export const iconsaxCardSend = "/assets/icons/iconsax/card-send.svg";
export const iconsaxCardRemove = "/assets/icons/iconsax/card-remove.svg";
export const iconsaxCardRemove1 = "/assets/icons/iconsax/card-remove-1.svg";
export const iconsaxCardReceive = "/assets/icons/iconsax/card-receive.svg";
export const iconsaxCardPos = "/assets/icons/iconsax/card-pos.svg";
export const iconsaxCardEdit = "/assets/icons/iconsax/card-edit.svg";
export const iconsaxCardCoin = "/assets/icons/iconsax/card-coin.svg";
export const iconsaxCardAdd = "/assets/icons/iconsax/card-add.svg";
export const iconsaxCar = "/assets/icons/iconsax/car.svg";
export const iconsaxCandle = "/assets/icons/iconsax/candle.svg";
export const iconsaxCandle2 = "/assets/icons/iconsax/candle-2.svg";
export const iconsaxCamera = "/assets/icons/iconsax/camera.svg";
export const iconsaxCameraSlash = "/assets/icons/iconsax/camera-slash.svg";
export const iconsaxCall = "/assets/icons/iconsax/call.svg";
export const iconsaxCallSlash = "/assets/icons/iconsax/call-slash.svg";
export const iconsaxCallRemove = "/assets/icons/iconsax/call-remove.svg";
export const iconsaxCallReceived = "/assets/icons/iconsax/call-received.svg";
export const iconsaxCallOutgoing = "/assets/icons/iconsax/call-outgoing.svg";
export const iconsaxCallMinus = "/assets/icons/iconsax/call-minus.svg";
export const iconsaxCallIncoming = "/assets/icons/iconsax/call-incoming.svg";
export const iconsaxCallCalling = "/assets/icons/iconsax/call-calling.svg";
export const iconsaxCallAdd = "/assets/icons/iconsax/call-add.svg";
export const iconsaxCalendar = "/assets/icons/iconsax/calendar.svg";
export const iconsaxCalendarTick = "/assets/icons/iconsax/calendar-tick.svg";
export const iconsaxCalendarSearch = "/assets/icons/iconsax/calendar-search.svg";
export const iconsaxCalendarRemove = "/assets/icons/iconsax/calendar-remove.svg";
export const iconsaxCalendarEdit = "/assets/icons/iconsax/calendar-edit.svg";
export const iconsaxCalendarCircle = "/assets/icons/iconsax/calendar-circle.svg";
export const iconsaxCalendarAdd = "/assets/icons/iconsax/calendar-add.svg";
export const iconsaxCalendar2 = "/assets/icons/iconsax/calendar-2.svg";
export const iconsaxCalendar1 = "/assets/icons/iconsax/calendar-1.svg";
export const iconsaxCalculator = "/assets/icons/iconsax/calculator.svg";
export const iconsaxCake = "/assets/icons/iconsax/cake.svg";
export const iconsaxBuyCrypto = "/assets/icons/iconsax/buy-crypto.svg";
export const iconsaxBus = "/assets/icons/iconsax/bus.svg";
export const iconsaxBurgerMenu = "/assets/icons/iconsax/burger-menu.svg";
export const iconsaxBuliding = "/assets/icons/iconsax/buliding.svg";
export const iconsaxBuildings = "/assets/icons/iconsax/buildings.svg";
export const iconsaxBuildings2 = "/assets/icons/iconsax/buildings-2.svg";
export const iconsaxBuilding = "/assets/icons/iconsax/building.svg";
export const iconsaxBuilding4 = "/assets/icons/iconsax/building-4.svg";
export const iconsaxBuilding3 = "/assets/icons/iconsax/building-3.svg";
export const iconsaxBucketSquare = "/assets/icons/iconsax/bucket-square.svg";
export const iconsaxBucketSquare1 = "/assets/icons/iconsax/bucket-square-1.svg";
export const iconsaxBucketCircle = "/assets/icons/iconsax/bucket-circle.svg";
export const iconsaxBucketCircle1 = "/assets/icons/iconsax/bucket-circle-1.svg";
export const iconsaxBubble = "/assets/icons/iconsax/bubble.svg";
export const iconsaxBrush = "/assets/icons/iconsax/brush.svg";
export const iconsaxBrush3 = "/assets/icons/iconsax/brush-3.svg";
export const iconsaxBrush2 = "/assets/icons/iconsax/brush-2.svg";
export const iconsaxBrush1 = "/assets/icons/iconsax/brush-1.svg";
export const iconsaxBroom = "/assets/icons/iconsax/broom.svg";
export const iconsaxBrifecaseTimer = "/assets/icons/iconsax/brifecase-timer.svg";
export const iconsaxBrifecaseTick = "/assets/icons/iconsax/brifecase-tick.svg";
export const iconsaxBrifecaseCross = "/assets/icons/iconsax/brifecase-cross.svg";
export const iconsaxBriefcase = "/assets/icons/iconsax/briefcase.svg";
export const iconsaxBox = "/assets/icons/iconsax/box.svg";
export const iconsaxBoxTime = "/assets/icons/iconsax/box-time.svg";
export const iconsaxBoxTick = "/assets/icons/iconsax/box-tick.svg";
export const iconsaxBoxSearch = "/assets/icons/iconsax/box-search.svg";
export const iconsaxBoxRemove = "/assets/icons/iconsax/box-remove.svg";
export const iconsaxBoxAdd = "/assets/icons/iconsax/box-add.svg";
export const iconsaxBox2 = "/assets/icons/iconsax/box-2.svg";
export const iconsaxBox1 = "/assets/icons/iconsax/box-1.svg";
export const iconsaxBookmark = "/assets/icons/iconsax/bookmark.svg";
export const iconsaxBookmark2 = "/assets/icons/iconsax/bookmark-2.svg";
export const iconsaxBook = "/assets/icons/iconsax/book.svg";
export const iconsaxBookSquare = "/assets/icons/iconsax/book-square.svg";
export const iconsaxBookSaved = "/assets/icons/iconsax/book-saved.svg";
export const iconsaxBook1 = "/assets/icons/iconsax/book-1.svg";
export const iconsaxBlur = "/assets/icons/iconsax/blur.svg";
export const iconsaxBlur1 = "/assets/icons/iconsax/blur-1.svg";
export const iconsaxBluetooth = "/assets/icons/iconsax/bluetooth.svg";
export const iconsaxBluetoothRectangle = "/assets/icons/iconsax/bluetooth-rectangle.svg";
export const iconsaxBluetoothCircle = "/assets/icons/iconsax/bluetooth-circle.svg";
export const iconsaxBluetooth2 = "/assets/icons/iconsax/bluetooth-2.svg";
export const iconsaxBlend = "/assets/icons/iconsax/blend.svg";
export const iconsaxBlend2 = "/assets/icons/iconsax/blend-2.svg";
export const iconsaxBitcoinRefresh = "/assets/icons/iconsax/bitcoin-refresh.svg";
export const iconsaxBitcoinConvert = "/assets/icons/iconsax/bitcoin-convert.svg";
export const iconsaxBitcoinCard = "/assets/icons/iconsax/bitcoin-card.svg";
export const iconsaxBill = "/assets/icons/iconsax/bill.svg";
export const iconsaxBezier = "/assets/icons/iconsax/bezier.svg";
export const iconsaxBezier1 = "/assets/icons/iconsax/bezier-1.svg";
export const iconsaxBatteryFull = "/assets/icons/iconsax/battery-full.svg";
export const iconsaxBatteryEmpty = "/assets/icons/iconsax/battery-empty.svg";
export const iconsaxBatteryEmpty1 = "/assets/icons/iconsax/battery-empty-1.svg";
export const iconsaxBatteryDisable = "/assets/icons/iconsax/battery-disable.svg";
export const iconsaxBatteryCharging = "/assets/icons/iconsax/battery-charging.svg";
export const iconsaxBattery3full = "/assets/icons/iconsax/battery-3full.svg";
export const iconsaxBarcode = "/assets/icons/iconsax/barcode.svg";
export const iconsaxBank = "/assets/icons/iconsax/bank.svg";
export const iconsaxBag = "/assets/icons/iconsax/bag.svg";
export const iconsaxBagTimer = "/assets/icons/iconsax/bag-timer.svg";
export const iconsaxBagTick = "/assets/icons/iconsax/bag-tick.svg";
export const iconsaxBagTick2 = "/assets/icons/iconsax/bag-tick-2.svg";
export const iconsaxBagHappy = "/assets/icons/iconsax/bag-happy.svg";
export const iconsaxBagCross = "/assets/icons/iconsax/bag-cross.svg";
export const iconsaxBagCross1 = "/assets/icons/iconsax/bag-cross-1.svg";
export const iconsaxBag2 = "/assets/icons/iconsax/bag-2.svg";
export const iconsaxBackward = "/assets/icons/iconsax/backward.svg";
export const iconsaxBackwardItem = "/assets/icons/iconsax/backward-item.svg";
export const iconsaxBackwardItem1 = "/assets/icons/iconsax/backward-item-1.svg";
export const iconsaxBackward5Seconds = "/assets/icons/iconsax/backward-5-seconds.svg";
export const iconsaxBackward15Seconds = "/assets/icons/iconsax/backward-15-seconds.svg";
export const iconsaxBackward10Seconds = "/assets/icons/iconsax/backward-10-seconds.svg";
export const iconsaxBackSquare = "/assets/icons/iconsax/back-square.svg";
export const iconsaxAward = "/assets/icons/iconsax/award.svg";
export const iconsaxAutobrightness = "/assets/icons/iconsax/autobrightness.svg";
export const iconsaxAudioSquare = "/assets/icons/iconsax/audio-square.svg";
export const iconsaxAttachSquare = "/assets/icons/iconsax/attach-square.svg";
export const iconsaxAttachCircle = "/assets/icons/iconsax/attach-circle.svg";
export const iconsaxArrow = "/assets/icons/iconsax/arrow.svg";
export const iconsaxArrowUp = "/assets/icons/iconsax/arrow-up.svg";
export const iconsaxArrowUp3 = "/assets/icons/iconsax/arrow-up-3.svg";
export const iconsaxArrowUp2 = "/assets/icons/iconsax/arrow-up-2.svg";
export const iconsaxArrowUp1 = "/assets/icons/iconsax/arrow-up-1.svg";
export const iconsaxArrowSwapHorizontal = "/assets/icons/iconsax/arrow-swap-horizontal.svg";
export const iconsaxArrowSquare = "/assets/icons/iconsax/arrow-square.svg";
export const iconsaxArrowSquareUp = "/assets/icons/iconsax/arrow-square-up.svg";
export const iconsaxArrowSquareRight = "/assets/icons/iconsax/arrow-square-right.svg";
export const iconsaxArrowSquareLeft = "/assets/icons/iconsax/arrow-square-left.svg";
export const iconsaxArrowSquareDown = "/assets/icons/iconsax/arrow-square-down.svg";
export const iconsaxArrowRight = "/assets/icons/iconsax/arrow-right.svg";
export const iconsaxArrowRight3 = "/assets/icons/iconsax/arrow-right-3.svg";
export const iconsaxArrowRight2 = "/assets/icons/iconsax/arrow-right-2.svg";
export const iconsaxArrowRight1 = "/assets/icons/iconsax/arrow-right-1.svg";
export const iconsaxArrowLeft = "/assets/icons/iconsax/arrow-left.svg";
export const iconsaxArrowLeft3 = "/assets/icons/iconsax/arrow-left-3.svg";
export const iconsaxArrowLeft2 = "/assets/icons/iconsax/arrow-left-2.svg";
export const iconsaxArrowLeft1 = "/assets/icons/iconsax/arrow-left-1.svg";
export const iconsaxArrowDown = "/assets/icons/iconsax/arrow-down.svg";
export const iconsaxArrowDown2 = "/assets/icons/iconsax/arrow-down-2.svg";
export const iconsaxArrowDown1 = "/assets/icons/iconsax/arrow-down-1.svg";
export const iconsaxArrowCircleRight = "/assets/icons/iconsax/arrow-circle-right.svg";
export const iconsaxArrowCircleLeft = "/assets/icons/iconsax/arrow-circle-left.svg";
export const iconsaxArrowCircleDown = "/assets/icons/iconsax/arrow-circle-down.svg";
export const iconsaxArrowBottom = "/assets/icons/iconsax/arrow-bottom.svg";
export const iconsaxArrow3 = "/assets/icons/iconsax/arrow-3.svg";
export const iconsaxArrow2 = "/assets/icons/iconsax/arrow-2.svg";
export const iconsaxArrangeSquare = "/assets/icons/iconsax/arrange-square.svg";
export const iconsaxArrangeSquare2 = "/assets/icons/iconsax/arrange-square-2.svg";
export const iconsaxArrangeCircle = "/assets/icons/iconsax/arrange-circle.svg";
export const iconsaxArrangeCircle2 = "/assets/icons/iconsax/arrange-circle-2.svg";
export const iconsaxArchive = "/assets/icons/iconsax/archive.svg";
export const iconsaxArchiveTick = "/assets/icons/iconsax/archive-tick.svg";
export const iconsaxArchiveSlash = "/assets/icons/iconsax/archive-slash.svg";
export const iconsaxArchiveMinus = "/assets/icons/iconsax/archive-minus.svg";
export const iconsaxArchiveBook = "/assets/icons/iconsax/archive-book.svg";
export const iconsaxArchiveAdd = "/assets/icons/iconsax/archive-add.svg";
export const iconsaxArchive1 = "/assets/icons/iconsax/archive-1.svg";
export const iconsaxAquarius = "/assets/icons/iconsax/aquarius.svg";
export const iconsaxAlignVertically = "/assets/icons/iconsax/align-vertically.svg";
export const iconsaxAlignRight = "/assets/icons/iconsax/align-right.svg";
export const iconsaxAlignLeft = "/assets/icons/iconsax/align-left.svg";
export const iconsaxAlignHorizontally = "/assets/icons/iconsax/align-horizontally.svg";
export const iconsaxAlignBottom = "/assets/icons/iconsax/align-bottom.svg";
export const iconsaxAlarm = "/assets/icons/iconsax/alarm.svg";
export const iconsaxAirpods = "/assets/icons/iconsax/airpods.svg";
export const iconsaxAirpod = "/assets/icons/iconsax/airpod.svg";
export const iconsaxAirplane = "/assets/icons/iconsax/airplane.svg";
export const iconsaxAirplaneSquare = "/assets/icons/iconsax/airplane-square.svg";
export const iconsaxAirdrop = "/assets/icons/iconsax/airdrop.svg";
export const iconsaxAdditem = "/assets/icons/iconsax/additem.svg";
export const iconsaxAdd = "/assets/icons/iconsax/add.svg";
export const iconsaxAddSquare = "/assets/icons/iconsax/add-square.svg";
export const iconsaxAddCircle = "/assets/icons/iconsax/add-circle.svg";
export const iconsaxActivity = "/assets/icons/iconsax/activity.svg";
export const iconsax3square = "/assets/icons/iconsax/3square.svg";
export const iconsax3dcube = "/assets/icons/iconsax/3dcube.svg";
export const iconsax3dSquare = "/assets/icons/iconsax/3d-square.svg";
export const iconsax3dRotate = "/assets/icons/iconsax/3d-rotate.svg";
export const iconsax3dCubeScan = "/assets/icons/iconsax/3d-cube-scan.svg";
export const iconsax24Support = "/assets/icons/iconsax/24-support.svg";
export const customCloseV3 = "/assets/icons/custom/close-V3.svg";
export const customChevronRightV3 = "/assets/icons/custom/chevron-right-V3.svg";
export const customChevronLeftV3 = "/assets/icons/custom/chevron-left-V3.svg";
